import type { FormValues } from '@uturn/portal/modules/shipments/schema';
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
	Input,
} from '@uturn/ui-kit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function ShipmentGroup() {
	const { t } = useTranslation();
	const form = useFormContext<FormValues>();

	return (
		<div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-6">
			<div className="col-span-3 grid grid-cols-1 gap-6 sm:grid-cols-6">
				<div className="sm:col-span-full">
					<FormField
						control={form.control}
						name="newGroup.name"
						render={({ field }) => (
							<FormItem>
								<FormLabel className="required-asterix">
									{t('pages.shipment-details.group.name', 'Group name')}
								</FormLabel>
								<FormControl>
									<Input {...field} />
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>
				<div className="sm:col-span-3">
					<FormField
						control={form.control}
						name="numberOfCopiesToBeCreated"
						render={({ field }) => (
							<FormItem>
								<FormLabel className="required-asterix">
									{t(
										'pages.shipment-details.group.number-of-shipments',
										'Number of shipments',
									)}
								</FormLabel>
								<FormControl>
									<Input
										{...field}
										type="number"
										onChange={(e) => field.onChange(e.target.valueAsNumber)}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>
			</div>
		</div>
	);
}
